import React, { useEffect } from "react";
import { PropTypes } from 'prop-types';
import { Select } from "antd";
import { SelectOptionWrapper, NoResultsWrap } from "../styles";
import { basicImports } from '../../DefaultPropTypes';

export default function SelectComponent(props) {
  useEffect(() => {
    let multiSelectNode = document.querySelector(`input[id^='${props.id}']`);
    if(multiSelectNode) {
      multiSelectNode.setAttribute("id", `${props.id}testing`);
    }
  }, []);

  return (
    <Select
      role={false}
      aria-label={props.ariaLabel}
      showSearch
      disabled={props.disabled ? props.disabled : false}
      id={props.id}
      title={props.title}
      name={props.name}
      onSelect={props.onSelect}
      onBlur={props.onBlur}
      showArrow
      className={props.className||""}
      defaultActiveFirstOption={false}
      defaultValue="- Select -"
      value={props.value}
      placeholder={props.placeholder}
      notFoundContent={<NoResultsWrap>No results</NoResultsWrap>}
    >
      {props.dropdown &&
        props.dropdown.map((freq,index) => (
          <Select.Option key={index+1} value={freq.desc}>
            <SelectOptionWrapper>{freq.desc}</SelectOptionWrapper>
          </Select.Option>
        ))}
    </Select>
  );
}

SelectComponent.propTypes = {
  disabled: PropTypes.bool,
  dropdown: basicImports,
  id: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  showArrow: PropTypes.bool,
  showSearch: PropTypes.bool,
  value: PropTypes.any,
}
